module.exports = "/assets/career/team/malgorzata_marciniak.png?JkElqBs";